import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import '../styles/resfi.css';

export default function AboutPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div style={{ minHeight: '100vh', background: '#FFFFFF' }} data-testid="about-page">
      <Nav />

      {/* =========================================
          WHO WE ARE SECTION (Team)
      ========================================= */}
      <section
        style={{
          position: 'relative',
          overflow: 'hidden',
          background: '#FFFFFF',
          paddingTop: '5rem',
          paddingBottom: '1.5rem',
        }}
      >
        {/* Background image */}
        <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
          <img
            src="/assets/bgAbout.png"
            alt="Background Pattern"
            style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.6 }}
          />
        </div>

        <div className="container" style={{ position: 'relative', zIndex: 10 }}>
          {/* Who We Are heading */}
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h2
              data-testid="who-we-are-heading"
              style={{
                fontWeight: 700,
                fontSize: 'clamp(1.75rem, 4vw, 2.25rem)',
                color: '#0D0D0D',
                marginBottom: '0.75rem',
                letterSpacing: '-0.02em',
              }}
            >
              Who We Are
            </h2>
            <div style={{ height: '6px', width: '64px', background: '#4AAFC9', borderRadius: '999px', margin: '0 auto' }} />
          </div>

          {/* Team Cards */}
          <div
            style={{
              display: 'flex',
              gap: '1.5rem',
              overflowX: 'auto',
              paddingBottom: '1rem',
              paddingLeft: '1rem',
              paddingRight: '1rem',
              scrollSnapType: 'x mandatory',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              maxWidth: '56rem',
              margin: '0 auto',
            }}
            className="about-team-grid"
            data-testid="team-cards"
          >
            {/* Card 1: Asheet Mehta */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              style={{
                minWidth: '72vw',
                maxWidth: '320px',
                background: '#EAF7FF',
                padding: '1.5rem',
                borderRadius: '2rem',
                textAlign: 'center',
                boxShadow: '0 10px 40px rgba(0,10,40,0.03)',
                flexShrink: 0,
                scrollSnapAlign: 'start',
                transition: 'box-shadow 0.5s',
              }}
              className="team-card"
              data-testid="team-card-asheet"
            >
              <div
                style={{
                  width: '140px',
                  height: '140px',
                  background: '#CBD5E1',
                  borderRadius: '1.5rem',
                  margin: '0 auto 1.25rem',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <img
                  src="/assets/asheet.jpg"
                  alt="Asheet Mehta"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 18%' }}
                />
              </div>
              <div style={{ marginBottom: '0.75rem' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#0D0D0D', letterSpacing: '-0.02em', marginBottom: '0.25rem' }}>
                  Asheet Mehta
                </h3>
                <p style={{ color: '#4AAFC9', fontWeight: 600, fontSize: '0.625rem', textTransform: 'uppercase', letterSpacing: '0.15em' }}>
                  CEO &amp; FOUNDER
                </p>
              </div>
              <p style={{ fontSize: '0.875rem', color: '#64748B', fontWeight: 500, lineHeight: 1.5 }}>
                Driven by a passion to help consumers achieve their best financial outcomes.
                <br />
                Former Senior Partner and Co-head of Global Financial Services McKinsey &amp; Co
              </p>
            </motion.div>

            {/* Card 2: Kshitij Gupta */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              style={{
                minWidth: '72vw',
                maxWidth: '320px',
                background: '#EAF7FF',
                padding: '1.5rem',
                borderRadius: '2rem',
                textAlign: 'center',
                boxShadow: '0 10px 40px rgba(0,10,40,0.03)',
                flexShrink: 0,
                scrollSnapAlign: 'start',
                transition: 'box-shadow 0.5s',
              }}
              className="team-card"
              data-testid="team-card-kshitij"
            >
              <div
                style={{
                  width: '140px',
                  height: '140px',
                  background: '#CBD5E1',
                  borderRadius: '1.5rem',
                  margin: '0 auto 1.25rem',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <img
                  src="/assets/Kshtij.png"
                  alt="Kshitij Gupta"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div style={{ marginBottom: '0.75rem' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#0D0D0D', letterSpacing: '-0.02em', marginBottom: '0.25rem' }}>
                  Kshitij Gupta
                </h3>
                <p style={{ color: '#4AAFC9', fontWeight: 600, fontSize: '0.625rem', textTransform: 'uppercase', letterSpacing: '0.15em' }}>
                  FOUNDING TEAM
                </p>
              </div>
              <p style={{ fontSize: '0.875rem', color: '#64748B', fontWeight: 500, lineHeight: 1.5 }}>
                Committed to making everyday financial life simpler and more empowering.
                <br />
                Startup operator with deep experience building Fintech and AI products from 0&#8594;1
              </p>
            </motion.div>
          </div>

          {/* Mobile indicator dots */}
          <div
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginTop: '1rem', paddingBottom: '0.5rem' }}
            className="mobile-dots"
          >
            <div style={{ width: '6px', height: '6px', borderRadius: '999px', background: '#4AAFC9' }} />
            <div style={{ width: '6px', height: '6px', borderRadius: '999px', background: '#CBD5E1' }} />
          </div>

          {/* Founding Team Logos */}
          <div style={{ paddingTop: '1.5rem', paddingBottom: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h2
              data-testid="founding-team-heading"
              style={{
                fontWeight: 700,
                fontSize: 'clamp(1.25rem, 3vw, 1.75rem)',
                color: '#0D0D0D',
                letterSpacing: '-0.02em',
                marginBottom: '0.5rem',
                textAlign: 'center',
              }}
            >
              Founding Team is From
            </h2>

            {/* Logos Marquee */}
            <div style={{ position: 'relative', width: '100%', overflow: 'hidden', padding: '1rem 0' }}>
              {/* Fade edges */}
              <div style={{ position: 'absolute', inset: '0 auto 0 0', width: '80px', background: 'linear-gradient(to right, #ffffff, transparent)', zIndex: 10 }} />
              <div style={{ position: 'absolute', inset: '0 0 0 auto', width: '80px', background: 'linear-gradient(to left, #ffffff, transparent)', zIndex: 10 }} />

              <motion.div
                style={{ display: 'flex', alignItems: 'center', gap: '3rem', width: 'fit-content' }}
                animate={{ x: ['0%', '-50%'] }}
                transition={{ duration: 35, repeat: Infinity, ease: 'linear' }}
              >
                {[0, 1].map((_, i) => (
                  <div key={`marquee-${i}`} style={{ display: 'flex', alignItems: 'center', gap: '3rem', padding: '0 1rem' }}>
                    {[1, 2, 3, 4, 5, 6, 7].map((num) => {
                      let maxHeight = '42px';
                      let maxWidth = '160px';
                      if (num === 4) { maxHeight = '58px'; maxWidth = '140px'; }
                      if (num === 5) { maxHeight = '50px'; maxWidth = '150px'; }
                      return (
                        <div
                          key={`${i}-${num}`}
                          style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.7, transition: 'opacity 0.5s' }}
                          onMouseEnter={e => e.currentTarget.style.opacity = '1'}
                          onMouseLeave={e => e.currentTarget.style.opacity = '0.7'}
                        >
                          <img
                            src={`/assets/F${num}.svg`}
                            alt={`Founding Institution ${num}`}
                            style={{ maxHeight, maxWidth, width: 'auto', objectFit: 'contain' }}
                          />
                        </div>
                      );
                    })}
                  </div>
                ))}
              </motion.div>
            </div>

            {/* We Are Hiring */}
            <div style={{ textAlign: 'center', paddingTop: '1.5rem', paddingBottom: '1rem' }}>
              <a
                href="/careers"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="we-are-hiring-link"
                style={{
                  color: '#4AAFC9',
                  fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
                  fontWeight: 700,
                  fontStyle: 'italic',
                  textDecoration: 'none',
                  transition: 'opacity 0.3s',
                }}
                onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
                onMouseLeave={e => e.currentTarget.style.opacity = '1'}
              >
                We Are Hiring
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          BRAND NARRATIVE SECTION
      ========================================= */}
      <section
        style={{
          position: 'relative',
          overflow: 'hidden',
          background: 'linear-gradient(180deg, #CCF5FF 0%, #FFFFFF 44%, #E7F3FF 89%)',
        }}
      >
        <div className="container" style={{ maxWidth: '80rem', padding: '0 1.5rem' }}>
          <div className="about-narrative-grid">
            {/* Left: Mission Card */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              style={{
                marginTop: '2.5rem',
                background: '#FFFFFF',
                borderRadius: '2.5rem',
                padding: '2.5rem',
                boxShadow: '0 20px 50px rgba(8,112,184,0.12)',
                border: '1px solid #F8FAFC',
              }}
              className="mission-card"
              data-testid="mission-card"
            >
              <span
                style={{
                  color: '#4AAFC9',
                  fontWeight: 700,
                  fontSize: '1.125rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.15em',
                  marginBottom: '1.5rem',
                  display: 'block',
                }}
              >
                Our Mission
              </span>
              <h2
                style={{
                  fontSize: 'clamp(1.5rem, 3vw, 1.75rem)',
                  fontWeight: 800,
                  color: '#0D0D0D',
                  lineHeight: 1.2,
                  marginBottom: '2rem',
                }}
              >
                We aim to make finance responsible to help customers achieve financial independence
              </h2>
              <div style={{ height: '6px', width: '64px', background: '#4AAFC9', borderRadius: '999px', marginBottom: '2.5rem' }} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', color: '#64748B', fontWeight: 500, lineHeight: 1.7, fontSize: '0.9375rem' }}>
                <p>
                  We want to deliver the best financial outcomes for our customers by delighting and
                  surprising them and putting them on a path to financial independence.
                </p>
                <p>
                  We do this by autonomously managing and optimizing your cashflow to save on interest
                  expense, pay down debt faster, save more, and invest said savings to have more
                  money left over to spend on life's necessities and desires.
                </p>
              </div>
            </motion.div>

            {/* Right: Brand Story */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              style={{ paddingTop: '2.5rem' }}
            >
              <h2
                data-testid="about-resfi-heading"
                style={{
                  fontSize: 'clamp(2rem, 5vw, 3.75rem)',
                  fontWeight: 700,
                  color: '#0D0D0D',
                  marginBottom: '2.5rem',
                  letterSpacing: '-0.02em',
                  lineHeight: 1.1,
                }}
              >
                About <span style={{ color: '#4AAFC9' }}>resfi</span>
              </h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', fontSize: '0.9375rem', color: '#4A5568', lineHeight: 1.7, fontWeight: 500 }}>
                <p>
                  When we started resfi.ai we started with the notion that if we had to start a
                  financial technology company from scratch, we would not build our company the
                  way current financial services are designed, managed, or offered.
                </p>
                <p>
                  We started by putting the customer at the center of everything we do &ndash; this means
                  not only our financial needs but also the complicated emotions we have related to
                  money. We aim to meet all such needs over time and do it without relying on legacy
                  technology that compromises experience, without fine print or hidden fees, and
                  without business models that are misaligned with customers' interests.
                </p>
                <p>
                  As a result, we measure ourselves by the financial outcomes we deliver for our
                  customers. Every product and service must provide clear, distinctive value and a
                  superior experience. Our fees and rates are fair, transparent, and simple,
                  enabling us to serve our customers sustainably and earn their trust.
                </p>
                <p>
                  We will leverage AI and best-in-class data to simplify finance and make it
                  autonomous, as we live up to our customer promise and deliver more value and
                  delight to our customers.
                </p>
                <p>
                  To that end, we are a team of curious thinkers and learners who strive to understand
                  not only customer pain points but also the emotions that go with managing their
                  financial lives.
                </p>
                <p>
                  We are building an organization that values a customer-first mindset, innovative
                  and responsible thinking, great execution and building trust and leading with integrity.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* =========================================
          OUR VALUES SECTION
      ========================================= */}
      <section style={{ paddingTop: '3rem', paddingBottom: '6rem', background: '#F8F8F8' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2
              data-testid="our-values-heading"
              style={{
                fontSize: 'clamp(2rem, 5vw, 3rem)',
                fontWeight: 700,
                color: '#0D0D0D',
                letterSpacing: '-0.02em',
              }}
            >
              Our Values
            </h2>
            <div style={{ height: '6px', marginTop: '0.75rem', width: '96px', background: '#4AAFC9', borderRadius: '999px', margin: '0.75rem auto 0' }} />
          </div>

          <div className="values-grid" data-testid="values-grid" style={{ padding: '0.5rem' }}>
            {[
              {
                title: 'Stewards of your finances',
                desc: "When customers put their trust in us by \"banking\" with us, we become stewards of their finances. Our mission is to help our customers achieve their best financial outcomes and for us to act as their advocate by giving and implementing advice that is both in our customer's interests and sustainable for us.",
                icon: '/assets/Icon1.svg',
              },
              {
                title: 'Profit Only on Progress',
                desc: 'We align our revenue with customer success. We refuse to build "poverty-traps-features" that rely on late fees, hidden interest, or user mistakes to be profitable. If the math doesn\'t improve a customer\'s net worth, we don\'t ship it.',
                icon: '/assets/Icon2.svg',
              },
              {
                title: 'Built for Simplicity',
                desc: 'Complexity in financial services turns off customers by making them unsure or feeling like they do not always understand what they are buying and getting. Our aim is to simplify and automate everything we can. We remove unnecessary layers and design every product, term, and cost to be inherently simple. If it feels complicated, it\'s broken.',
                icon: '/assets/Icon3.svg',
              },
              {
                title: 'Engineered to be Responsible',
                desc: 'Responsibility is built into the system, not added later. We embed compliance, ethics, and customer advocacy into every decision. Our platform prevents over-leverage, prioritizes safety and security, and guides users toward sustainable financial outcomes automatically. We aspire to work with best-in-class partners and communities to build a growing, aligned ecosystem where value flows back to consumers, enabling mutual growth and long-term trust.',
                icon: '/assets/Icon4.svg',
              },
              {
                title: 'Designed For Delight',
                desc: 'In a world of stressful banking, we solve for joy. Whether it\'s an unprompted rate drop or a hidden savings gap we filled while the customer was sleeping, we strive to surprise our users with progress they weren\'t even looking for. We turn financial anxiety into the delight of automated growth.',
                icon: '/assets/Icon5.svg',
              },
              {
                title: 'Ideas Over Hierarchy',
                desc: 'We are a meritocracy of "Owners" where the best idea wins, regardless of title. We value the radical curiosity of builders who challenge the status quo and the ambition of teams who grow by solving the hardest problems. No one has a monopoly on insight; we all have an obligation to drive the mission forward.',
                icon: '/assets/Icon6.svg',
              },
              {
                title: 'Bias for Action',
                desc: "Financial stress doesn't wait for strategy discussions, and neither do we. We value the \"builder\" who identifies a friction point in a customer's journey and moves immediately to fix it. We measure our success by the speed at which we solve real-world problems.",
                icon: '/assets/Icon7.svg',
              },
            ].map((value, index) => (
              <motion.div
                key={value.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                className="value-card"
                data-testid={`value-card-${index}`}
                style={{
                  background: '#FFFFFF',
                  borderRadius: '2.5rem',
                  padding: '2rem 2.5rem',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.03)',
                  border: '1px solid #F8FAFC',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  transition: 'box-shadow 0.3s, transform 0.3s',
                }}
                whileHover={{ y: -4, boxShadow: '0 20px 50px rgba(0,0,0,0.10)' }}
              >
                <div
                  style={{
                    width: '50px',
                    height: '50px',
                    background: 'rgba(74, 175, 201, 0.15)',
                    borderRadius: '2rem',
                    marginBottom: '1rem',
                    position: 'relative',
                    overflow: 'hidden',
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={value.icon}
                    alt={value.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                <h3
                  style={{
                    fontSize: 'clamp(1.25rem, 2.5vw, 1.75rem)',
                    fontWeight: 700,
                    color: '#0D0D0D',
                    marginBottom: '1.5rem',
                    lineHeight: 1.2,
                    minHeight: '3rem',
                  }}
                >
                  {value.title}
                </h3>
                <div style={{ height: '6px', width: '64px', background: '#4AAFC9', borderRadius: '999px', marginBottom: '2rem' }} />
                <p style={{ color: '#4A5568', fontWeight: 500, lineHeight: 1.7, fontSize: '0.9375rem' }}>
                  {value.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
